module.exports = __webpack_public_path__ + "img/home.b8263f8a.svg";